/******************************************
 *  Author : Author   
 *  Created On : Fri Sep 03 2021
 *  File : SigninOidc.js
 *******************************************/

import React, { useEffect } from "react"
import { useHistory } from "react-router-dom"
import { signinRedirectCallback } from "../services/userService"
import { AuthContext } from '../utils/authProvider';

function SigninOidc() {
    const history = useHistory();
    const userManager = React.useContext(AuthContext);
    useEffect(() => {

        async function signinAsync() {
            try {
                await signinRedirectCallback(userManager);
            }
            catch {
                //intentionally empty; the compiler reaches this point when you click the "Back" button
            }
            let redirectUrl = sessionStorage.getItem('redirectUrl');
            if (redirectUrl) {
                sessionStorage.removeItem('redirectUrl');
            }
            else {
                redirectUrl = '/';
            }
            history.push(redirectUrl);
        }

        signinAsync();
    },
        [history]);

    return (
        <div>
            Redirecting...
        </div>
    );
}

export default SigninOidc